export const SET_ACTIVE_INDEX = 'player/SET_ACTIVE_INDEX'
export const SET_SHOW_PLAYER = 'player/SET_SHOW_PLAYER'

export const setActiveIndex = (payload) => ({ type: SET_ACTIVE_INDEX, payload })

export const setShowPlayer = (payload) => ({ type: SET_SHOW_PLAYER, payload })


/** WEBPACK FOOTER **
 ** ./src/actions/player.actions.js
 **/